import { Logger } from '@lynx/client-core/src/modules'
import { useThunkDispatch } from 'hooks/useThunkDispatch'
import { HomePage } from 'pages/HomePage'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { readConfig } from 'store/config'
import css from './App.module.css'
import { loginCookie } from 'store/profile'

export const App = (): React.ReactElement | null => {
	const { profile } = useSelector((state: ApplicationState) => state)
	const [loading, setLoading] = useState(true)

	const dispatchThunk = useThunkDispatch()

	const mount = async (): Promise<void> => {
		try {
			const config = await dispatchThunk(readConfig())
			if (!config) {
				Logger.error('Config not found')
				return
			}

			await dispatchThunk(loginCookie())
		} finally {
			setLoading(false)
		}
	}
	useEffect(() => {
		mount()
	}, [])
	const userNotLoggedInMessage = loading ? '' : 'User not logged in'

	return (
		<div className={css.container}>
			{profile.loggedIn ? <HomePage /> : userNotLoggedInMessage}
			<div className={css.buildVersion}>Version {process.env.REACT_APP_BUILD_VERSION}</div>
		</div>
	)
}
